<template>
  <div id="big-screen-wrapper" class="app-wrapper">
    <div class="large-bgi">
      <div class="app-title">
        <div class="title-bgi" @click="goTo">
          <div class="title"></div>
        </div>
        <div class="logo-block">
          <div class="top">
            <div class="logo"></div>
            <div class="text">{{ cText }}</div>
          </div>
          <div class="eText">{{ eText }}</div>
        </div>
        <div class="setting" @click="ensureState">
          <i class="icons el-icon-setting"></i>
        </div>
        <div v-if="show" class="setting-btns">
          <div
            v-if="showAdmin"
            class="setting-btns-item"
            @click="editPassword"
          >
            修改密码
          </div>
          <div class="setting-btns-item" @click="loginOut">退出登录</div>
        </div>

        <div class="title-time">
          <div class="icons"></div>
          <div class="detailTime">{{ detailTime }}</div>
          <div class="line">|</div>
          <div class="weekTime">{{ weekTime }}</div>
        </div>
      </div>
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </div>
    <el-dialog
      :visible="visibleShow"
      width="300px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="close-icon" @click="visibleShow = false"></div>
      <div class="title">修改密码</div>
      <div class="inner">
        <div class="common-form">
          <el-form
            ref="forms"
            :model="forms"
            :rules="rules"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="旧密码" prop="old">
              <el-input v-model="forms.old" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newVal">
              <el-input v-model="forms.newVal" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="copeNewVal">
              <el-input v-model="forms.copeNewVal" type="password"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="btns">
        <div class="btn ensure-btn" @click="handleEnsure">确定</div>
        <div class="btn close-btn" @click="handleClose">取消</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { loginOut, editPassword, loginInfo } from '@/api/user/index.js'
export default {
  name: 'Layout',
  data() {
    return {
      show: false,
      showAdmin: false,
      visibleShow: false,
      detailTime: '00:00:00',
      weekTime: '星期一 Monday 2021-01-01',
      timer: null,
      forms: {},
      userInfo: {},
      whiteList: ['appRepair'],
      cText: '',
      eText: '',
      rules: {
        old: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
        newVal: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        copeNewVal: [
          { required: true, message: '请确认新密码', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        if (val.name === 'Repair') {
          this.cText = '报修管理'
          this.eText = 'Repair Report Management'
        } else if (val.name === 'Home') {
          this.cText = '运维数据展示'
          this.eText = 'Operation and maintenance Data Display'
        } else if (val.name === 'User') {
          this.cText = '用户管理'
          this.eText = 'User management'
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    },
    visibleShow: {
      handler(val) {
        if (val) {
          this.loginInfo()
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.$nextTick(() => {
      this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    })
    console.log(this.userInfo, '22222')
    this.initTime()
    this.timer = setInterval(() => {
      this.initTime()
    }, 1000)
  },
  mounted() {

    // const scaleNum = window.innerWidth / 3200
    // document.getElementById('big-screen-wrapper').style.transform =
    //   'scale(' + scaleNum + ')'
    // document.getElementById('big-screen-wrapper').style.transformOrigin = '0 0'
    // window.onresize = function() {
    //   const scaleNum = window.innerWidth / 3200
    //   document.getElementById('big-screen-wrapper').style.transform =
    //     'scale(' + scaleNum + ')'
    //   document.getElementById('big-screen-wrapper').style.transformOrigin =
    //     '0 0'
    // }
  },
  methods: {
    ensureState() {
      console.log(this.userInfo)
      if (window.localStorage.getItem('userInfo')) {
        this.show = !this.show
        if (this.userInfo.userName !== 'admin') {
          this.showAdmin = true
        }
      } else {
        this.$message.error('获取用户信息异常,请重新登录')
        this.$router.push({ name: 'Login' })
      }
    },
    async handleEnsure() {
      // 不允许admin修改密码
      if (this.userInfo.userName !== 'admin') {
        this.$refs['forms'].validate((valid) => {
          if (valid) {
            if (this.forms.newVal !== this.forms.copeNewVal) {
              this.$message.error('新密码两次输入不一致')
            } else {
              editPassword(
                this.userInfo.id,
                this.forms.newVal,
                this.forms.old
              ).then((res) => {
                this.show = false
                this.visibleShow = false
                if (res.code === 0) {
                  this.$message({
                    message: '修改密码成功,请重新登录',
                    type: 'success'
                  })
                  window.localStorage.removeItem('token')
                  window.localStorage.removeItem('userInfo')
                  this.$router.push({ name: 'Login' })
                }
              })
            }
          } else {
            return false
          }
        })
      }
    },
    handleClose() {
      this.visibleShow = false
    },
    editPassword() {
      this.visibleShow = true
      this.show = false
    },
    async loginInfo() {
      const res = await loginInfo()
      this.userInfo = res.data
    },
    async loginOut() {
      const res = await loginOut()
      if (res.code === 0) {
        this.show = false
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userInfo')
        this.$router.push('/login')
      }
    },
    initTime() {
      this.detailTime = this.moment().format('HH:mm:ss')
      const eDate = this.moment().format('dddd yyyy-MM-DD')
      const date = new Date().getTime()
      this.weekTime = this.getWeek(date) + ' ' + eDate
    },
    goTo() {
      this.$router.push('/')
    },
    getWeek(date) {
      const week = this.moment(date).day()
      switch (week) {
        case 1:
          return '星期一'
        case 2:
          return '星期二'
        case 3:
          return '星期三'
        case 4:
          return '星期四'
        case 5:
          return '星期五'
        case 6:
          return '星期六'
        case 0:
          return '星期日'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  width: 700px !important;
  .el-form {
    margin-top: 50px;
    .el-form-item {
      margin-bottom: 50px;
    }
  }
}
.inner {
  padding: 100px 130px 0;
}
.setting {
  position: absolute;
  right: 60px;
  top: 20px;
  .icons {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }
}
.setting-btns {
  transition: 0.6s;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  z-index: 999;
  position: absolute;
  right: 0px;
  top: 50px;
  .setting-btns-item {
    color: rgba($color: #000000, $alpha: 0.7);
    cursor: pointer;
    line-height: 40px;
    font-size: 20px;
  }
}
.logo-block {
  .top {
    display: flex;
    align-items: flex-end;
    .logo {
      width: 141px;
      height: 56px;
      background: url(../assets/homeleft/logo.png) no-repeat;
      background-size: 100% 100%;
    }
    .text {
      letter-spacing: 10px;
      font-size: 30px;
      font-weight: 400;
      color: #ffffff;
      opacity: 0.8;
      margin: 0 0 4px 7px;
    }
  }
  .eText {
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;
    opacity: 0.5;
    letter-spacing: 5px;
    margin: 7px;
  }
}
.app-wrapper {
  width: 3200px;
  height: 1077px;
  overflow: hidden;
  background-color: #00072a;
  // background: url("../assets/layout/main-bgi.png") no-repeat;
  // background-size: 100% 100%;
  padding: 10px 60px 40px;
  position: relative;
  .large-bgi {
    width: 3200px;
    height: 1080px;
    background: url("../assets/layout/large-bgi.png") no-repeat;
    background-size: 100% 100%;
    padding: 10px 60px 40px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .app-title {
    width: 100%;
    height: 67px;
    position: relative;
    .title-bgi {
      cursor: pointer;
      width: 1440px;
      height: 100%;
      background: url("../assets/layout/title-bgi.png") no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      left: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: translate(-50%);
      .title {
        width: 358px;
        height: 30px;
        background: url("../assets/layout/title-text.png");
      }
    }
    .title-time {
      width: 486px;
      position: absolute;
      top: 0;
      right: 120px;
      line-height: 67px;
      color: #fff;
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .icons {
        width: 26px;
        height: 26px;
        background: url("../assets/layout/time.png");
      }
      .line {
        color: #24cefc;
        opacity: 0.2;
      }
    }
  }
}
</style>
